class MiniCartCount extends HTMLElement {
  constructor() {
    super();

    const setCount = (count) => {
      if (!count || count === 0) {
        this.innerHTML = "";
        return;
      }

      this.innerHTML =
        count === 1
          ? this.dataset.one
          : this.dataset.other.replace("[count]", count);
    };

    if (window.cartData?.item_count) {
      setCount(window.cartData.item_count);
    }

    document.addEventListener("cart:updated", (e) => {
      setCount(e.detail.cartData.item_count);
    });
  }
}

if (!customElements.get("mini-cart-count")) {
  customElements.define("mini-cart-count", MiniCartCount);
}
